import React, { useState, useEffect } from 'react'
import { Line } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);



 const Linechart = ({labels, data1, data2, name1, name2}) => {
    const data = {

        // labels: ['Jan' , 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        labels: labels,
        datasets: [
          {
            fill: false,
            // label: 'Inbound calls',
            label: name1,
            // data:  [0, 10, 20, 30],
            data:  data1,
            borderColor: '#E40077',
            backgroundColor:'#E40077',
            tension: 0.2,
            borderWidth: 2,
            pointRadius: 0
          },
          {
            fill: false,
            // label: 'Outbound Calls',
            label: name2,
            // data:  [0, 5, 10, 15, 20, 25, 30],
            data:  data2,
            borderColor: '#8FC31F',
            backgroundColor:'#8FC31F',
            tension: 0.2,
            borderWidth: 2,
            pointRadius: 0 
            
          },
        ],

        
      
      
      }

        const options = {
          responsive: true,
          plugins: {
          legend: {
          position: 'bottom',
          label:{
            usePointStyle:true
          }
          },
        //   dataLabels:{
        //     anchor: 'end',
        //     align: 'top',
        //     formatter: function(value) {
        //         if (value >= 1000) {
        //           return (value / 1000).toFixed(0) + 'k';
        //         }
        //         return value;
        //   }
        //   },
          title: {
          display: true,
          // text: 'Chart.js Line Chart',
          },
          },
          }
        
        return <Line options={options} data={data}  
        // plugins={[ChartDataLabels]} 
        />;
      }
export default Linechart;